import createIcon from '../../createIcon';

/**
 * @component @name QrCode
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxMUgxMVYzSDNWMTFaTTUgNUg5VjlINVY1WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTMgMjFIMTFWMTNIM1YyMVpNNSAxNUg5VjE5SDVWMTVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMgM1YxMUgyMVYzSDEzWk0xOSA5SDE1VjVIMTlWOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxOUgxOVYyMUgyMVYxOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNSAxM0gxM1YxNUgxNVYxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNyAxNUgxNVYxN0gxN1YxNVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNSAxN0gxM1YxOUgxNVYxN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xNyAxOUgxNVYyMUgxN1YxOVoiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSAxN0gxN1YxOUgxOVYxN1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0xOSAxM0gxN1YxNUgxOVYxM1oiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGQ9Ik0yMSAxNUgxOVYxN0gyMVYxNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const QrCode = createIcon('QrCode', [
  ['path', { d: 'M3 11H11V3H3V11ZM5 5H9V9H5V5Z', key: '1w78ug' }],
  ['path', { d: 'M3 21H11V13H3V21ZM5 15H9V19H5V15Z', key: '3xlfiv' }],
  ['path', { d: 'M13 3V11H21V3H13ZM19 9H15V5H19V9Z', key: 'tprguu' }],
  ['path', { d: 'M21 19H19V21H21V19Z', key: 'wy541k' }],
  ['path', { d: 'M15 13H13V15H15V13Z', key: '16bppr' }],
  ['path', { d: 'M17 15H15V17H17V15Z', key: '1rq2ee' }],
  ['path', { d: 'M15 17H13V19H15V17Z', key: '1updph' }],
  ['path', { d: 'M17 19H15V21H17V19Z', key: '1cumhy' }],
  ['path', { d: 'M19 17H17V19H19V17Z', key: '1ombub' }],
  ['path', { d: 'M19 13H17V15H19V13Z', key: '1j8ksk' }],
  ['path', { d: 'M21 15H19V17H21V15Z', key: '1984fp' }],
]);

export default QrCode;
